import { connect } from 'react-redux'
import { setSearchHelperVisible } from 'redux/actions'
import InfoHelperButton from 'components/layout/search/InfoHelperButton'

const mapStateToProps = state => ({
  searchHelperVisible: state.search.searchHelperVisible
})

const mapDispatchToProps = dispatch => ({
  setSearchHelperVisible: searchHelperVisible => dispatch(setSearchHelperVisible(searchHelperVisible))
})

export default connect(mapStateToProps, mapDispatchToProps)(InfoHelperButton)
